import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-subscription-expired-dialog",
  templateUrl: "./subscription-expired-dialog.component.html",
})
export class SubscriptionExpiredDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  goToStripe(stripeLink: string) {
    window.open(stripeLink);
  }
}
